export default __webpack_public_path__ + "static/media/loader.6281c6f4.gif";